import $axios from "../../api";

const state = {
  isLoading: false,
  createLoading: false,
  exportTxtLoading: false,
  exportExcelLoading: false,
  exportPdfLoading: false,
  errors: "",
  isSuccess: false,
  list: {
    data: [],
    total: 0,
    per_page: 10,
    from: 0,
    to: 0,
  },
  detailLoading: false,
  detail: {},

  stockerPayload: null,
  page: 1,
};

const getters = {
  errors: (state) => {
    let errors = {};

    Object.keys(state.errors).forEach((key) => {
      const part = key.split(".");

      if (part[0] === "products" || part[0] === "additional_products") {
        const productIndex = Number(part[1]);
        
        errors[key] = state.errors[key][0] + ` (SKU: ${state.stockerPayload?.[part[0]][productIndex]?.sku || 'N/A'})`;

        if (part[3]) {
          const batchIndex = Number(part[3]);

          errors[key] += ` (Baris ke: ${batchIndex + 1})`;
        }
      }
    });
    return errors;
  },
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },

  SET_CREATE_LOADING(state, payload) {
    state.createLoading = payload;
  },

  SET_ERRORS(state, payload) {
    state.errors = payload;
  },

  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },

  SET_LIST(state, payload) {
    state.list = payload;
  },

  SET_DETAIL(state, payload) {
    state.detail = payload;
  },

  SET_PAGE(state, payload) {
    state.page = payload;
  },
  
  RESET_DETAIL(state) {
    state.detail = [];
  },

  RESET_ERRORS(state) {
    state.errors = {};
  },

  RESET_STATE(state) {
    state.errors = {};
    state.isSuccess = false;
    state.createLoading = false;
  },

  SET_DETAIL_LOADING(state, val) {
    state.detailLoading = val;
  },

  SET_STOCKER_PAYLOAD(state, payload) {
    state.stockerPayload = payload;
  }
  ,
  SET_PRODUCT_DETAIL(state, payload) {
    state.detail = {
      ...state.detail,
      product_name: payload.product_name,
      sku: payload.sku
    };
  },
  SET_EXPORT_TXT_LOADING(state, value) {
    state.exportTxtLoading = value;
  },
  SET_EXPORT_EXCEL_LOADING(state, value) {
    state.exportExcelLoading = value;
  },
  SET_EXPORT_PDF_LOADING(state, value) {
    state.exportPdfLoading = value;
  },

  RESET_STOCKER_PAYLOAD(state) {
    state.stockerPayload = null;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload = "") {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(
          `inv/stock-opname/list?page=${state.page}&view=${rootState.Main.view}${payload}`
        )
        .then((response) => {
          commit("SET_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        });
    });
  },

  getView({ commit, dispatch }, docNum) {
    commit("SET_DETAIL_LOADING", true);
    commit("RESET_DETAIL");

    return $axios
      .get(`inv/stock-opname/view/${docNum}`)
      .then((res) => {
        commit("SET_DETAIL", res.data.data);
        return res;
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_DETAIL_LOADING", false);
      });
  },

  createVisit({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOADING", true);
    commit("SET_ERRORS", null);
    commit("SET_SUCCESS", false);

    return $axios
      .post("inv/stock-opname/create", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        commit("SET_SUCCESS", true);

        dispatch(
          "Main/globalSuccessSweetAlert",
          response.data?.message || "Data berhasil disimpan",
          { root: true }
        );

        return response;
      })
      .catch((error) => {
        const errors = error.response?.data?.errors || null;

        commit("SET_ERRORS", errors);
        commit("SET_SUCCESS", false);

        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );

        throw error;
      })
      .finally(() => {
        commit("SET_CREATE_LOADING", false);
      });
  },


  updateVisit({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOADING", true);
    commit("SET_SUCCESS", false);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/update", payload)
        .then((response) => {
          commit("SET_CREATE_LOADING", false);
          commit("SET_SUCCESS", true);

          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );

          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOADING", false);
          commit("SET_ERRORS", error.response?.data?.errors || "");
          commit("SET_SUCCESS", false);

          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );

          reject(error);
        });
    });
  },

  exportTxt({ commit }, id) {
    commit("SET_EXPORT_TXT_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/txt/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/plain" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `stock-opname-${id}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .finally(() => {
        commit("SET_EXPORT_TXT_LOADING", false);
      });
  },

  exportExcel({ commit, dispatch }, id) {
    commit("SET_EXPORT_EXCEL_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/excel/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        let filename = "export.xlsx";

        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("filename=") !== -1) {
          const matches = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_EXPORT_EXCEL_LOADING", false);
      });
  },

  exportPdf({ commit, dispatch }, id) {
    commit("SET_EXPORT_PDF_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/pdf/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/pdf",
        });

        const url = window.URL.createObjectURL(blob);

        // 👉 OPEN PREVIEW DI TAB BARU
        window.open(url, "_blank");

        // revoke setelah delay biar tab kebuka dulu
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_EXPORT_PDF_LOADING", false);
      });
  },
  
  showhide({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/showhide", payload)
        .then((response) => {
          commit("SET_SUCCESS", true);

          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );

          resolve(response);
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);

          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );

          reject(error);
        });
    });
  },

  fetchDetail({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(`inv/stock-opname/stocker/detail/${payload}`)
        .then((response) => {
          commit("SET_STOCKER_PAYLOAD", response.data.data);
          resolve();
        })
        .catch((error) => {
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject();
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  scanBarcode({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(`inv/stock-opname/stocker/scan-barcode/${payload.code}`, {
          params: {
            doc_num: payload?.doc_num,
            code_type: payload?.code_type || null,
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  submit({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/stocker/submit/" + payload?.schedule_id, payload?.payload)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response?.data?.errors || "");
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  importMacroSales({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .post(`inv/stock-opname/stocker/import-macro-sales/${payload.schedule_id}`, payload.body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response?.data?.errors || "");
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
